import { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Grid,
} from '@forgeglobal/design-framework';
import { useStyles } from './style';
import useAuthentication from '@tcs/common/hooks/useAuthentication';

const PROMPT_TIMEOUT = 1000 * 60;
const SESSION_TIMEOUT = 1000 * 60 * 10;

const IdleTimer = () => {
  const { signOut } = useAuthentication();
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const [remaining, setRemaining] = useState(0);

  const onPrompt = () => {
    setOpen(true);
    setRemaining(PROMPT_TIMEOUT / 1000);
  };

  const onIdle = () => {
    setOpen(false);
    setRemaining(0);
    signOut();
  };

  const onActive = () => {
    setOpen(false);
    setRemaining(0);
  };

  const { reset, getRemainingTime, isPrompted } = useIdleTimer({
    timeout: SESSION_TIMEOUT,
    promptTimeout: PROMPT_TIMEOUT,
    onIdle,
    onPrompt,
    onActive,
    crossTab: false,
    debounce: 500,
  });

  const handleStillHere = () => {
    setOpen(false);
    reset();
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (isPrompted()) {
        setRemaining(Math.ceil(getRemainingTime() / 1000));
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [getRemainingTime, isPrompted]);

  return (
    <Dialog open={open} transitionDuration={0}>
      <DialogTitle onClose={handleStillHere}>Session Timeout</DialogTitle>
      <DialogContent className={classes.wrapper}>
        <div className={classes.content}>
          <Typography variant="body1" className={classes.text}>
            Your session will expire in {remaining} seconds. Do you want to keep
            this session?
          </Typography>
          <Grid container spacing={2} className={classes.buttons}>
            <Grid item>
              <Button color="secondary" onClick={() => signOut()}>
                No
              </Button>
            </Grid>
            <Grid item>
              <Button color="primary" onClick={handleStillHere}>
                Yes
              </Button>
            </Grid>
          </Grid>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default IdleTimer;
